// Shared helpers for merging the "Basement Area Disclosure" modal's free-text note into
// the Reconciliation Commentary field(s) (`reconciliationCommentary` / `aivReconciliationCommentary`
// / `arvReconciliationCommentary`), so the note is visible on the Reconciliation page and included
// in the PDF report, instead of being tracked in a separate, unrendered field.

export const BASEMENT_AREA_DISCLOSURE_HEADING = 'Basement Area Disclosure:';

const DISCLOSURE_BLOCK_REGEX = new RegExp(
  String.raw`\n*${BASEMENT_AREA_DISCLOSURE_HEADING}[\s\S]*$`,
);

export const extractBasementAreaDisclosureNote = (commentary?: string): string => {
  const match = commentary?.match(DISCLOSURE_BLOCK_REGEX);
  if (!match) return '';
  return match[0].replace(BASEMENT_AREA_DISCLOSURE_HEADING, '').trim();
};

export const hasBasementAreaDisclosureNote = (commentary?: string): boolean =>
  extractBasementAreaDisclosureNote(commentary).length > 0;

export const mergeBasementAreaDisclosureNote = (
  commentary: string | undefined,
  note: string,
): string => {
  const base = (commentary ?? '').replace(DISCLOSURE_BLOCK_REGEX, '').trimEnd();
  const trimmedNote = note.trim();
  if (!trimmedNote) return base;
  return base
    ? `${base}\n\n${BASEMENT_AREA_DISCLOSURE_HEADING} ${trimmedNote}`
    : `${BASEMENT_AREA_DISCLOSURE_HEADING} ${trimmedNote}`;
};
